import { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "../../lms/component/tabPanel/tabPanel";
import "../reportDashboard.scss";

const SECTIONS = [
  { key: "overview", label: "Overview" },
  { key: "inspections", label: "Inspections" },
  { key: "incidents", label: "Incidents & Cases" },
  { key: "credentials", label: "Credentials & Training" },
  { key: "assets", label: "Assets" },
  { key: "benchmarks", label: "Benchmarks" },
  { key: "users", label: "Users" },
  { key: "subcontractors", label: "Subcontractors" },
];

const SectionTabs = ({ children, onSectionChange, toolbar }) => {
  const [value, setValue] = useState(0);

  const handleChange = (e, v) => {
    setValue(v);
    // Switching sections is local state, not a route change, so nothing in the
    // router or the page-level fetch re-validates the viewing grant here. Most
    // sections re-request their own lists on mount, but Overview and
    // Benchmarks render purely from the payload fetched at page load and would
    // never touch the network — so a viewer whose link was revoked mid-session
    // could keep browsing them. This ping closes that.
    if (onSectionChange) onSectionChange(v);
  };

  return (
    <div>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        className="rdTabs"
      >
        {SECTIONS.map((s, i) => (
          <Tab
            key={s.key}
            className="rdTabs__tab"
            label={s.label}
            id={`dashboard-tab-${i}`}
          />
        ))}
      </Tabs>
      {/* Phase 1 UI fix: the date-range bar renders here — right after the tab
          strip and before any panel — so it reads as a bar of its own between
          the two, matching the v26 mockup's stacked .section-bar/.datefilter-bar
          layout. DashboardShell builds the bar's contents (label + filter +
          "Updating…") and hands it down as this slot; SectionTabs itself stays
          unaware of what a "date range" is. */}
      {toolbar}
      {SECTIONS.map((s, i) => (
        <TabPanel key={s.key} value={value} index={i}>
          {children[i]}
        </TabPanel>
      ))}
    </div>
  );
};

export default SectionTabs;
